import { render, staticRenderFns } from "./HeadMenu.vue?vue&type=template&id=6d483548&"
import script from "./HeadMenu.vue?vue&type=script&lang=js&"
export * from "./HeadMenu.vue?vue&type=script&lang=js&"
import style0 from "./HeadMenu.vue?vue&type=style&index=0&id=6d483548&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports